import "../styles/engagements.scss";
import "../styles/engagements_mobile.scss";
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import BusinessIcon from '@material-ui/icons/Business';
import un from "./img/1.jpg";
import deux from "./img/2.jpg";
import trois from "./img/3.jpg";
import quatre from "./img/4.png";
import cinq from "./img/5.jpg";
import six from"./img/6.jpg";
import sept from "./img/7.jpg";
import huit from "./img/8.jpg";

import {useState,useEffect} from "react";
import { useSelector,useDispatch } from "react-redux";
import {selectPrestations,setPrestation,setPrestations} from "../features/counterSlice";

import {useHistory} from "react-router-dom";
import Share from "./Share";

const Engagements=()=>{
	
	const p=useSelector(selectPrestations);
	
	const [data,set_data]=useState(null);
    const history=useHistory();
    const dispatch=useDispatch();
    
	
	useEffect(()=>{
		if(p==null) return;
		set_data(p);
	},[p])
    
    return(
        <div className="engagements">
            <div className="top">
                <h1>Nos prestations</h1>
            </div>
            <div className="content">

                {
                    data?.map((item,i)=>{
                        return(
                            <div key={i} className="relative cursor-pointer" onClick={()=>{
                                dispatch(setPrestation(item));
                                history.push("/details-prestation")
                            }}>
                                    <img src={item.acf?.image?.url} style={{height:150,objectFit:"cover",width:"100%"}} />
                                    <h3>{item.title.rendered}</h3>
                                    <p>{item.acf?.a_propos}</p>  

                                    
                            </div>
                        )
                    })
                }
                
            </div>
        </div>
    );
}
export default Engagements;